module.exports = __webpack_public_path__ + "static/media/bank_hxyh.a1734972.png";